import React from "react";

//Assets
import elco from "../../Assets/elco.png";

//UI Material
import { Box } from "@mui/system";

export default function ElcoLogo({ height = "45px" }) {
  return (
    <Box sx={{ padding: "10px" }}>
      <img src={elco} height={height} alt="logo atila" />
    </Box>
  );
}
